import React from 'react';
import ReactDOM from 'react-dom';
import { store } from './store/configureStore'
import { Provider } from 'react-redux'
import App from './App';
import reportWebVitals from './reportWebVitals';
import './scss/index.scss';

// window.pendingFuncs = [];

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
